<template>
  <div class="tooltip">
    <slot />
    <div
      class="tooltip-arrow"
      data-popper-arrow
    />
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  name: 'Tooltip',
  props: {
    dom: {
      type: [Object, String],
      default: ''
    },
    // popperjs 参数, 参考文档 https://popper.js.org/docs/v2/constructors/
    options: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    const { dom, $el, options } = this
    if (dom) {
      const el = dom instanceof Element ? dom : document.querySelector(dom)

      createPopper(el, $el, options)
    }
  }
}
</script>

<style scoped>
.tooltip-arrow::before {
  display: block;
  width: var(--size, 6px);
  height: var(--size, 6px);
  background: var(--bg, #333);
  content: '';
  transform: rotate(45deg);
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: calc(var(--size, 6px) / -2);
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: calc(var(--size, 6px) / -2);
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: calc(var(--size, 6px) / -2);
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: calc(var(--size, 6px) / -2);
}
</style>
